import { ref } from 'vue'

const toasts = ref([])
let nextId = 1

export const useToasts = () => {
  const addToast = (toast) => {
    const id = nextId++
    const newToast = {
      id,
      type: 'info',
      duration: 5000,
      persistent: false,
      ...toast
    }
    
    toasts.value.push(newToast)
    
    // Auto-remove after duration (if not persistent)
    if (!newToast.persistent && newToast.duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, newToast.duration)
    }
    
    return id
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearAllToasts = () => {
    toasts.value = []
  }

  // Convenience methods
  const success = (title, message, options = {}) => {
    return addToast({ type: 'success', title, message, ...options })
  }

  const error = (title, message, options = {}) => {
    return addToast({ type: 'error', title, message, ...options })
  }

  const warning = (title, message, options = {}) => {
    return addToast({ type: 'warning', title, message, ...options })
  }

  const info = (title, message, options = {}) => {
    return addToast({ type: 'info', title, message, ...options })
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearAllToasts,
    success,
    error,
    warning,
    info
  }
}

// Global instance for easy access
export const toastManager = useToasts()

export default useToasts
